import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from "@tanstack/react-query"
import type { Invoice } from "@tfg/db"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useListInvoicesQuery = (organizationId: string) => {
  return useQuery<Invoice[]>({
    queryKey: ["admin", "organizations", organizationId, "invoices"],

    queryFn: async () => {
      const response = await httpClient.get(
        `admin/organizations/${organizationId}/invoices`
      )
      return response.data
    },
  })
}

export type InvoiceForm = {
  reference: string
  amount: number
  documentId: string
}

export const useCreateInvoiceMutation = (
  organizationId: string,
  options?: UseMutationOptions<Invoice, AxiosError, InvoiceForm>
) => {
  return useMutation<Invoice, AxiosError, InvoiceForm>({
    mutationKey: ["invoice"],

    mutationFn: async (variables) => {
      const response = await httpClient.post(
        `admin/organizations/${organizationId}/invoices`,
        variables
      )
      return response.data
    },

    ...options,

    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: ["admin", "organizations", organizationId, "invoices"],
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
